import React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface CreateResponsableDialogProps {
  open: boolean;
  nombre: string;
  dni: string;
  telefono: string;
  email: string;
  isSubmitting: boolean;
  error: string | null;
  onClose: () => void;
  onChange: (values: Partial<{ nombre: string; dni: string; telefono: string; email: string; error: string | null }>) => void;
  onSubmit: (values: { nombre: string; email: string; dni?: string; telefono?: string }) => Promise<void>;
}

export const CreateResponsableDialog: React.FC<CreateResponsableDialogProps> = ({
  open,
  nombre,
  dni,
  telefono,
  email,
  isSubmitting,
  error,
  onClose,
  onChange,
  onSubmit,
}) => (
  <Dialog open={open} onOpenChange={(state) => {
    if (!state) onClose();
  }}>
    <DialogContent className="max-w-md max-h-[90dvh] overflow-y-auto">
      <form
        onSubmit={async (event) => {
          event.preventDefault();
          await onSubmit({ nombre, dni, telefono, email });
        }}
        className="space-y-4"
      >
        <DialogHeader>
          <DialogTitle>Nuevo responsable</DialogTitle>
          <DialogDescription>
            Completá los datos de contacto del responsable para vincularlo al trámite.
            Se creará automáticamente un usuario con una contraseña temporal.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3">
          <div className="space-y-2">
            <Label htmlFor="responsable-nombre">Nombre</Label>
            <Input
              id="responsable-nombre"
              value={nombre}
              onChange={(event) => onChange({ nombre: event.target.value })}
              required
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="responsable-dni">DNI</Label>
            <Input
              id="responsable-dni"
              value={dni}
              onChange={(event) => onChange({ dni: event.target.value })}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="responsable-telefono">Teléfono</Label>
            <Input
              id="responsable-telefono"
              value={telefono}
              onChange={(event) => onChange({ telefono: event.target.value })}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="responsable-email">Email *</Label>
            <Input
              id="responsable-email"
              type="email"
              value={email}
              onChange={(event) => onChange({ email: event.target.value })}
              required
              placeholder="ejemplo@email.com"
            />
            <p className="text-xs text-muted-foreground">
              Requerido para crear el usuario en el sistema
            </p>
          </div>
        </div>

        {error && <p className="text-sm text-rose-600">{error}</p>}

        <DialogFooter className="gap-3 pt-2">
          <Button type="button" variant="outline" onClick={onClose} disabled={isSubmitting}>
            Cancelar
          </Button>
          <Button type="submit" loading={isSubmitting} disabled={isSubmitting}>
            Guardar responsable
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);
